import * as $ from 'jquery';
import * as fJS from '../../../mixins/cjsRoot/fJS';

export class PanelDraw {
  _size;
  _colors;
  _erase;
  _multicolor;
  constructor(obj) {
    this.size = fJS.isNumeric(obj.sizePen) ? obj.sizePen : 35;
    this._multicolor = true;
    this.colors = [];
    if (Array.isArray(obj.colors) === true) {
      for (let i = 0; i < obj.colors.length; i++) {
        this.colors.push({
          val: obj.colors[i],
          active: i == 0,
        });
      }
    }
    this.erase = false;
  }

  changeColor(obj) {
    for (let i = 0; i < this._colors.length; i++) {
      if (this._colors[i].val !== obj.val) {
        this._colors[i].active = false;
        continue;
      }
      this._colors[i].active = true;
    }
  }

  set size(v) {
    this._size = v;
  }

  get size() {
    return this._size;
  }

  get colors() {
    return this._colors;
  }
  set colors(v) {
    this._colors = v;
  }

  set erase(v) {
    this._erase = v;
  }
  get erase() {
    return this._erase;
  }

  get multicolor() {
    return this._multicolor;
  }
}
